import zh from "../locales/zh.json";
import { SUPPORTED_LANGUAGES, type Language } from "./languages";

type Catalog = Record<string, string>;
export const catalogs: Partial<Record<Language, Catalog>> = { zh, en: {} };
export const registerCatalog = (language: Language, catalog: Catalog): void => { catalogs[language] = catalog; };

// English phrases are catalog keys. Replace placeholders once, without interpreting
// replacement syntax ($&, $1) or placeholders contained in user-supplied text.
export const ui = (language: Language, source: string, ...values: (string | number)[]): string => {
  const catalog = catalogs[language];
  const template = catalog && Object.hasOwn(catalog, source) ? catalog[source] : source;
  return template.replace(/\{(\d+)\}/g, (match, index: string) => values[Number(index)] === undefined ? match : String(values[Number(index)]));
};

export const localizedCopies = <T>(create: (language: Language) => T): Record<Language, T> => {
  const cache = new Map<Language, { catalog: Catalog | undefined; value: T }>();
  return Object.defineProperties({}, Object.fromEntries(SUPPORTED_LANGUAGES.map((language) => [language, {
    enumerable: true,
    get: () => {
      const catalog = catalogs[language];
      if (!cache.has(language) || cache.get(language)!.catalog !== catalog) cache.set(language, { catalog, value: create(language) });
      return cache.get(language)!.value;
    },
  }]))) as Record<Language, T>;
};
export const localizedText = (source: string): Record<Language, string> => localizedCopies((language) => ui(language, source));
